import { useEffect, useRef } from "react";

import { Stack } from "@mui/material";

import { AvailableLoads } from "components/AvailableLoads";
import { MultiShipmentProjectBookingsTable } from "components/Carrier/components/MultiShipmentProjectBookingsTable";
import { ErrorTypography } from "components/ErrorTypography";
import { LoadingWrappedNode } from "components/LoadingWrappedNode";
import {
  useMultiShipmentProjectBookingsAsCarrier,
  useShipmentPageContext,
} from "hooks";

interface Props {
  dividerComponent: JSX.Element;
  shipmentId: number | undefined;
}
export function MultiShipmentProjectBookingsSection(props: Props) {
  const { dividerComponent, shipmentId } = props;
  const { shipment } = useShipmentPageContext();
  const shipmentRef = useRef<undefined | CondensedShipment>();
  const { projectBookings, refetchBookings, loading, error } =
    useMultiShipmentProjectBookingsAsCarrier(shipmentId);

  useEffect(() => {
    if (
      shipmentRef.current != null &&
      shipmentRef.current.version !== shipment?.version
    ) {
      refetchBookings();
    }
    shipmentRef.current = shipment;
  }, [shipment, refetchBookings]);

  if (
    shipment?.project === undefined ||
    shipment.project == null ||
    shipment.info.type !== "MULTI_SHIPMENT_PROJECT"
  ) {
    return null;
  }

  return (
    <Stack direction="column" mb="1rem">
      {dividerComponent}
      <ErrorTypography error={error} />
      <LoadingWrappedNode loading={loading}>
        <Stack direction="column" spacing={2}>
          <AvailableLoads shipment={shipment} variant="h6" />
          <MultiShipmentProjectBookingsTable
            bookings={projectBookings}
            quotingUnitOfMeasure={shipment.info.quoting_unit_of_measure}
          />
        </Stack>
      </LoadingWrappedNode>
    </Stack>
  );
}
